import React, { useEffect, useState } from 'react';

import './index.sass'
import omit from 'lodash/omit';
import mapKeys from 'lodash/mapKeys';
import Text from 'components/Text';
//import { serialize } from 'object-to-formdata';
import { Formik, useFormikContext } from 'formik';
import { Button } from 'components/Button';
import bem from 'utils/bem';
//import { useToasts } from 'react-toast-notifications';
import PhoneField from 'forms/fields/PhoneField';
import TextField from 'forms/fields/TextField';
import BirthdayField from 'forms/fields/BirthdayField';
import validationSchema from './validationSchema';
import { observer } from 'mobx-react-lite';
import EmailField from 'forms/fields/EmailField';
import GenderField from 'forms/fields/GenderField';
import UserAgreementCheckboxField from 'forms/fields/UserAgreementCheckboxField';
import Model from '../../../../model';
import PasswordField from 'forms/fields/PasswordField';
import FormikPhoneField from 'forms/fields/PhoneField/FormikPhoneField';
import { useNavigate } from 'react-router';
import RegisterPhoneField from 'forms/fields/PhoneField/RegisterPhoneField';

const { block, el } = bem( 'register-form', 'form' );

const defaultValues = {
    customerPhone: '',
    customerSkype: '',
    customerName: '',
    customerEmail: '',
    customerSurname: '',
    customerSex: 'M',
    customerBirthday: '',
    password: '',
    passwordConfirmation: '',
    code: ''
};

const RegisterForm =  ( { redirect = '/profile', switchToLogin, resetCurrentForm } ) => {

    const { authenticate } = Model.user;
    //const { addToast } = useToasts();

    const navigate = useNavigate();

    const handleSubmit = (values, form) => {
        const formData = new FormData();

        formData.append('password', values.password);
        formData.append('code', values.code)

        const newValues = omit(values, ['code', 'password', 'passwordConfirmation', 'acceptConditions'])
        const snakedValues = mapKeys(newValues, (_value, key) => key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`))
        Object.keys(snakedValues).forEach(key => formData.append(`customer_data[${key}]`, snakedValues[key]));

        fetch('/register', {
            method: 'POST',
            body: formData
        }).then((promise) => {
            return promise.json();
        }).then((response) => {
            console.log(response);
            if (response.success) {
                authenticate({ username: response.user });
                navigate(redirect);
                form.resetForm();
                form.setSubmitting(false);
                Model.modal.closeLoginForm();
            } else {
                //addToast('Произошла ошибка', { appearance: 'error', autoDismiss: true });
                form.resetForm();
                form.setSubmitting(false);
            }
        }).catch(err => {
            console.error(err);
            throw (err, 'something went wrong')
        });

    };

    const rForm = ( form ) => {

        return (
            <form className={ block() } onSubmit={ form.handleSubmit }>
                <div className={el('top-block')}>
                    <div className={el('title')}>
                        <Text serif>Регистрация</Text>
                    </div>
                    <div className={ el( 'fields' ) }>
                        <div className={ el( 'name' ) }>
                            <TextField
                                placeholder={'Ваше имя'}
                                name='customerName'
                            />
                        </div>
                        <div className={ el( 'surname' ) }>
                            <TextField
                                placeholder={'Ваша фамилия'}
                                name='customerSurname'
                            />
                        </div>
                        <div className={ el( 'password' ) }>
                            <PasswordField
                                name={'password'}
                                placeholder={'Пароль'} />
                        </div>
                        <div className={ el( 'password-confirmation' ) }>
                            <PasswordField
                                name={'passwordConfirmation'}
                                placeholder={'Подтверждение пароля'} />
                        </div>
                        <div className={ el( 'phone' ) }>
                            <RegisterPhoneField />
                        </div>
                        <div className={ el( 'email' ) }>
                            <EmailField
                                name='customerEmail'
                            />
                        </div>
                        <div className={ el( 'skype' ) }>
                            <TextField
                                placeholder={'Ваш Skype'}
                                name='customerSkype'
                            />
                        </div>
                        <div className={ el( 'sex' ) }>
                            <GenderField
                                placeholder={'Пол'}
                                name='customerSex'
                            />
                        </div>
                        <div className={ el( 'birthday' ) }>
                            <BirthdayField name='customerBirthday'/>
                        </div>
                        <div className={ el( 'code' ) }>
                            <TextField
                                placeholder={'Код сертификата'}
                                name='code'
                            />
                            <div className={el('code-exists')}>
                                <Text>Если есть</Text>
                            </div>
                        </div>
                    </div>
                    <UserAgreementCheckboxField name='acceptConditions' />
                </div>
                <div className={ el( 'buttons' ) }>
                    <Button className={ el( 'button', 'submit' ) }
                            type='submit'
                            mod={  'gold'  }
                            disabled={ form.isSubmitting } >
                        <Text>Зарегистрироваться</Text>
                    </Button>
                    <div className={ el( 'login' ) }
                            onClick={switchToLogin}>
                        <Text serif>Войти</Text>
                    </div>
                </div>
            </form>
        );
    };

    return (
        <Formik
            initialValues={ defaultValues }
            onSubmit={ handleSubmit }
            enableReinitialize={ true }
            validationSchema={ validationSchema }
            validateOnChange={ false }
            validateOnBlur={ false }>
            { (form) => rForm(form) }
        </Formik>
    )
};

export default observer( RegisterForm );
